import { RefObject, useEffect, useRef } from "react";

//Syncs react-pdf page width with the container.

export function usePdfContainerWidth(
  containerRef: RefObject<HTMLElement | null>,
  setPdfWidth: (width: number) => void
): void {
  const setPdfWidthRef = useRef(setPdfWidth);
  setPdfWidthRef.current = setPdfWidth;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateWidth = () => {
      const w = container.clientWidth;
      if (w > 0) setPdfWidthRef.current(w);
    };

    // dimensions update one tick after orientationchange on iOS Safari
    const updateWidthDeferred = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(updateWidth);
      });
    };

    const observer = new ResizeObserver(updateWidth);
    observer.observe(container);
    updateWidth();

    window.addEventListener("resize", updateWidth);
    window.addEventListener("orientationchange", updateWidthDeferred);
    const visualViewport = window.visualViewport;
    visualViewport?.addEventListener("resize", updateWidth);
    visualViewport?.addEventListener("scroll", updateWidth);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", updateWidth);
      window.removeEventListener("orientationchange", updateWidthDeferred);
      visualViewport?.removeEventListener("resize", updateWidth);
      visualViewport?.removeEventListener("scroll", updateWidth);
    };
  }, [containerRef]);
}
